import { HttpErrorCode } from '@inpart-io/devtools';

// We need to use this because the BE in normal PROD conditions should not return 400 /500 errors
const ExtendedHttpErrorCode = {
    ...HttpErrorCode,
    UNEXPECTED_CLIENT: 400,
    FORBIDDEN_USER: 500
} as const;

export const errorTypeCodes = ExtendedHttpErrorCode;
